<template>

  <div id="app_content" class="admin admin_updating_sync">

    <h1 class="mt-0">Gestione Aggiornamenti</h1>

    <section class="header">

      <button class="belt-btn-small" @click="notBool('manage_sync_info_admin')">
        <!-- <span><img class="icon" :src="url('/media/icons/png/options.png')" alt="Options icon"></span> -->
        <span>impostazioni</span>
      </button>

      <button class="belt-btn-small mr-1" @click="notBool('manage_sync_new')">nuovo aggiornamento</button>

      <span class="load-component" @click="loadUpdatingSync()">aggiorna lista</span>

    </section>

    <section class="elements admin-section" :class="{v_loading: loading}">

      <div class="filter-elements" v-show="false">

        <label class="w-100 block">Filtra Aggiornamneti</label>
        <input type="text" v-model="query" placeholder="parola chiave" name="query">

      </div>

      <ul v-if="filteredSync && filteredSync.length > 0" class="elements-list">

        <li v-for="(sync, i) in filteredSync" class="single-sync" :key="sync.id" :data-index="i">

          <sync-single :sync="sync"/>

        </li>

      </ul>

      <p v-else class="empty">Nessun aggiornamento trovato...</p>

    </section>

    <sync-info-admin v-if="manage_sync_info_admin" :sync_info_admin="sync_info_admin" :sync_admins="sync_admins"/>
    <sync-new v-if="manage_sync_new"/>

  </div>

</template>

<script>
import VsComponent from './../../vs-component'

import SyncSingle from './sync-single'
import SyncInfoAdmin from './sync-info-admin'
import SyncNew from './sync-new'
export default{

  components: {SyncSingle, SyncInfoAdmin, SyncNew, VsComponent},

  data: function(){

    return {
      vs_my_value: null,
      vs_options: [
        {label: '2020', value: '2020', otherdata: 'xax'},
        {label: '2019', value: '2019', otherdata: 'bvf'},
        {label: '2018', value: '2018', otherdata: 'ytr'},
      ],
      loading: false,
      updatings: [],
      sync_info_admin: null,
      sync_admins: [],
      query: '',
      manage_sync_info_admin: false,
      manage_sync_new: false,
    }

  },

  computed: {

    filteredSync: function(){

      return this.updatings;

    }

  },

  methods: {

    notBool: function(dataPropName){
      this[dataPropName] = !this[dataPropName];
    },

    loadUpdatingSync: function(){

      var vue = this;
      vue.loading = true;

      axios({
        method: "get",
        url: window.location.origin + '/data/updatings'
      })
      .then(res => {
        if( res.data.sync.updatings ) vue.updatings = res.data.sync.updatings;
        if( res.data.sync_info_admin ) vue.sync_info_admin = res.data.sync_info_admin;
        if( res.data.sync_admins ) vue.sync_admins = res.data.sync_admins;
      })
      .catch(err => {

        console.log( err.response );

        vue.$store.commit('add_message', {
          type: 'error',
          message: 'Si è verificato un errore, impossibile caricare la lista degli aggiornamenti'
        });

      })
      .then(() =>{
        vue.loading = false;
      })

    }

  },

  mounted: function(){

    this.loadUpdatingSync();

  }

}
</script>

<style scoped>
* >>> .load-component {
  color: var(--blue);
  text-decoration: underline;
  cursor: pointer;
}
section.elements{
  margin-top: 2em;
}
ul.elements-list{
  margin: 0;
  padding: 0;
  list-style-type: none;
}
ul.elements-list li{
  padding: 2em;
  border-bottom: 1px solid black;
}
input[name="query"]{
  padding: 5px 10px;
  border: 1px solid gray;
  width: 100%;
  max-width: 500px;
}
ul.elements-list li.single-sync[data-index="0"]{
  background-color: var(--disabled) !important;
}
ul.elements-list li.single-sync:nth-child(2n+1) {
	background-color: var(--background-gray-2);
}
ul.elements-list li.single-sync:nth-child(2n) {
	background-color: white;
}
</style>
